export const getters = {
  getContato: (state) => state.contato,
  getContatos: (state) => state.contatos,
  getModalCadastroContato: (state) => state.modalCadastroContato,
  getModalExcluirContato: (state) => state.modalExcluirContato,
  getModalPesquisarContato: (state) => state.modalPesquisarContato,
  getTiposContatos: (state) => state.tiposContatos,
  getTransportadoras: (state) => state.transportadoras,
  getFornecedores: (state) => state.fornecedores,
  getEstadoSelecionadoContato: (state) => state.estadoSelecionadoContato,
  getCidadeSelecionadaContato: (state) => state.cidadeSelecionadaContato,
};

export default {};
